export default function mrktoFormSetFormURL(form) {
    form.setValues({
        ...form.getValues(),
        ...{
            formURL: window.location.href
        }
    })
}
